"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _micromodal = _interopRequireDefault(require("micromodal"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 * Instantiate Micromodal and configure defaults across modal components.
 * - https://micromodal.now.sh/#configuration
 *
 * @namespace Modal
 */

/**
 * Create a new modal object.
 * @param {object} config - Settings for modal instance.
 */


var _default = function _default(selector, config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    disableScroll: false
  };
  /**
   * Instance settings.
   */
  // const settings = extendDefaults(defaults, config);

  /**
   * Instantiate a new modal.
   */

  function init() {
    _micromodal["default"].init(selector, defaults);
  }
  /**
   * Show modal with default settings.
   */


  function show() {
    _micromodal["default"].show(selector, defaults);
  }
  /**
   * Close modal with default settings.
   */


  function close() {
    _micromodal["default"].close(selector, defaults);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init,
    show: show,
    close: close
  });
};

exports["default"] = _default;